const transformListCreatedBy = (createdBy) => ({
  display: createdBy?.display,
  firstName: createdBy?.first_name,
  isAmbassador: createdBy?.is_ambassador,
  lastName: createdBy?.last_name,
  profilePicture: createdBy?.profile_image_url,
});
export default transformListCreatedBy;
